export const GET_DENTIST_DETAILS_REQUEST = "DENTIST_DETAILS/GET_DENTIST_DETAILS_REQUEST";
export const GET_DENTIST_DETAILS_SUCCESS = "DENTIST_DETAILS/GET_DENTIST_DETAILS_SUCCESS";
export const GET_DENTIST_DETAILS_FAILURE = "DENTIST_DETAILS/GET_DENTIST_DETAILS_FAILURE";



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/DentistDetails/constants.js